import * as React from 'react';
import { useEffect, useRef, useState , useMemo} from "react";
import {gridData} from '../data/grid-data'
import {gridColumnDefinitions} from '../data/grid-column-defs'

import { AgGridReact } from 'ag-grid-react'; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import "ag-grid-community/styles/ag-theme-balham.css";
import { Box } from '@mui/material';

export default function DemoDataGrid({onCellClick}){

  
const [rowData, setRowData] = useState(gridData)
  

// Mapping between the columns in data, columnnames to be shown on UI and their stylings.
 const [colDefs, setColDefs] = useState(gridColumnDefinitions)


const defaultColDef = useMemo(() => { 
	return {
        // set every column width
        width: 100,
        // make every column editable
        editable: true,
        // make every column use 'text' filter by default
        cellStyle: {color: 'black',  'textAlign': 'center','fontSize': '11px',} 
    };
}, []);

// function handling the rowclick 
const handleCellClicked = (params) => {  
  // calling the callback function using param   
  onCellClick(params);    
};

// Container: Defines the grid's theme & dimensions.An ag-grid should always bedefined within a div.
return (
  <Box className="ag-theme-quartz" sx = {{ width: '100%', height: '400px', overflowY: 'auto'}} >
    <AgGridReact 
    rowData={rowData} 
    columnDefs={colDefs}
    defaultColDef={defaultColDef}
    //domLayout={'autoHeight'}   
    //pagination={true} 
    //onCellClicked={handleCellClicked}
    onRowClicked = {handleCellClicked}
    />
  </Box>
);

}



